import store from "~/js/store/store";
import { gsap, Sine } from "gsap";
// Newsなど
export default class Selector {
  constructor() {
    const contents = document.querySelector(".c-selector");
    if (!contents) {
      return;
    }

    this.tabs = contents.querySelectorAll(".js-selector-tab");

    this.state = "Close"; //Brand, Item, Close
    this.subState = "Close"; //Womens, Mens, Bag, Accessories, Close

    this.setup();
  }

  setup() {
    for (var i = 0; i < this.tabs.length; i++) {
      let _tab = this.tabs[i];
      _tab.addEventListener("click", (event) => {
        let target = _tab.getAttribute("data-target");
        if (this.state != "Brand") {
          this.stateChange("Brand");
          this.scrollTo(event.currentTarget);
        } else {
          this.stateChange("Close");
        }
      });
    }
  }

  stateChange(_state) {
    this.state = _state;
    this.update(false);
    switch (this.state) {
      case "Brand":
        this.update(true);
        break;
      case "Item":
        /*for (var i = 0; i < this.itemTabs.length; i++) {
          this.itemTabs[i].classList.add("open");
        }*/
        // this.itemList.classList.add("open");
        break;
    }
  }

  update(isOpen = false) {
    for (var i = 0; i < this.tabs.length; i++) {
      let tab = this.tabs[i];
      let target = tab.getAttribute("data-target");
      if (isOpen) {
        tab.classList.add("open");
      } else {
        tab.classList.remove("open");
      }
      if (target) {
        let targetDOM = document.querySelector(target);
        if (targetDOM) {
          if (isOpen) {
            targetDOM.classList.add("open");
          } else {
            targetDOM.classList.remove("open");
          }
        }
      }
    }
  }

  scrollTo(_element) {
    if (store.getters["isSP"]()) {
      //SP
      var _rect = _element.getBoundingClientRect();
      var _top = _rect.top + window.pageYOffset;
      gsap.to(document.documentElement, {
        scrollTop: _top,
        duration: 0.6,
        ease: Sine.easeInOut
      });
    }
  }
}
